import { createContext, useState } from 'react';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Detecta o idioma do navegador (se inicia com 'pt' usa PT, caso contrário EN)
  const browserLanguage = navigator.language.toLowerCase().startsWith('pt') ? 'PT' : 'EN';
  const [language, setLanguage] = useState(browserLanguage);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}